export default "__VITE_ASSET__DJCaYlFE__"